<template>
  <div id="business">
    <div class="business_list">
      <div class="business_img">
        <img src="@/assets/content/business_01.png"
             width="40px" />
      </div>
      <div class="business_right">
        <div class="business_title">数据服务</div>
        <div class="business_con">数据购买、数据代理、数据编程</div>
        <div class="business_foot">
          <div class="business_foot_l">联系人：王先生</div>
          <div class="business_foot_r">电话：18933344907</div>
        </div>
      </div>
    </div>
    <div class="business_list">
      <div class="business_img">
        <img src="@/assets/content/business_02.png"
             width="40px" />
      </div>
      <div class="business_right">
        <div class="business_title">行业应用</div>
        <div class="business_con">卫星遥感监测、环境监测、国土监测、环保监测等行业监测服务</div>
        <div class="business_foot">
          <div class="business_foot_l">联系人：王先生</div>
          <div class="business_foot_r">电话：18933344907</div>
        </div>
      </div>
    </div>
    <div class="business_list">
      <div class="business_img">
        <img src="@/assets/content/business_03.png"
             width="40px" />
      </div>
      <div class="business_right">
        <div class="business_title">资源洽谈</div>
        <div class="business_con">卫星资源接入、输出，资源合作</div>
        <div class="business_foot">
          <div class="business_foot_l">联系人：王小姐</div>
          <div class="business_foot_r">电话：15089161243</div>
        </div>
      </div>
    </div>
    <div class="business_list">
      <div class="business_img">
        <img src="@/assets/content/business_04.png"
             width="40px" />
      </div>
      <div class="business_right">
        <div class="business_title">平台商务合作</div>
        <div class="business_con">平台商务合作，广告业务合作</div>
        <div class="business_foot">
          <div class="business_foot_l">联系人：王小姐</div>
          <div class="business_foot_r">电话：15089161243</div>
        </div>
      </div>
    </div>
    <div class="business_list">
      <div class="business_img">
        <img src="@/assets/content/business_05.png"
             width="40px" />
      </div>
      <div class="business_right">

        <div class="business_title">媒体合作</div>
        <div class="business_con">新闻宣传推广，行业展会</div>

        <div class="business_foot">
          <div class="business_foot_l">联系人：王小姐</div>
          <div class="business_foot_r">电话：15089161243</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}

</script>

<style scoped>
#business {
  width: 100%;
  font-weight: 400;
  color: #666666;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
}

#business img {
  margin: 0 auto;
  display: block;
}

.business_list {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebebeb;
  padding: 10px 0;
}

.business_right {
  width: 80%;
  display: flex;
  flex-direction: column;
}

.business_content {
  display: flex;
  align-items: center;
}

.business_img {
  width: 20%;
  text-align: center;
  float: left;
}

.business_title {
  font-size: 16px;
  font-weight: bold;
  line-height: 32px;
  color: #333;
  float: left;
}

.business_con {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 10px;
}

.business_foot {
  width: 100%;
  font-size: 14px;
}

.business_foot_l {
  width: 42%;
  float: left;
}

.business_foot_r {
  width: 58%;
  float: left;
}
</style>
